import { Section } from 'utils/types/contentfulTypes';

import { PressSectionV2Props } from './PressSectionV2';

const parsePressSectionV2Data = (
  section: Section,
): PressSectionV2Props | null => {
  if (!section) {
    return null;
  }
  return {
    title: section?.displayName,
    media: section?.images
      ? section.images.map((item) => ({
          desktopImage: item.desktopImage,
          desktopImageAltText: item.desktopImageAltText,
        }))
      : [],
  };
};

export default parsePressSectionV2Data;
